import React from "react";
import { Navigate } from "react-router-dom";
import { useAppSelector } from "../../redux/hooks.ts";

interface Props {
  children: React.ReactNode;
}

export const ProtectedMiddleware: React.FC<Props> = ({ children }) => {
  const { token, loading, userInfo } = useAppSelector((state) => state.auth);
  const isAuthorized = !!token;

  if (!loading && !token && !userInfo) return <Navigate to="/auth/login" />;

  return <>{isAuthorized ? children : <Navigate to="/auth/login" />}</>;
};
